(() => {
  const config = document.getElementById('WallifyWishlistConfig');
  if (!config) return;
  const labels = config.dataset;
  const key = 'wallify_favorites_v1';
  const selectionsKey = 'wallify_favorite_selections_v1';
  let selections = {};
  const root = labels.root.replace(/\/$/, '') + '/';
  const dialog = document.getElementById('WallifyWishlistDrawer');
  let items = [];
  let statusTimer;
  const pendingAdds = new Set();
  const cartSelection = new Set();
  let bulkBusy = false;
  let cartQueue = Promise.resolve();
  const quickDialog = document.getElementById('WallifyQuickBuy');
  let quickOrigin = null;
  let quickVersion = 0;
  let lockedPosition = null;
  const lockPage = () => {
    if (lockedPosition) return;
    lockedPosition = {x:window.scrollX, y:window.scrollY};
    document.documentElement.style.setProperty('--wallify-panel-top', -lockedPosition.y + 'px');
    document.documentElement.classList.add('wallify-panel-open');
  };
  const unlockPage = () => {
    if (dialog.open || quickDialog?.open || !lockedPosition) return;
    const position = lockedPosition;
    lockedPosition = null;
    document.documentElement.classList.remove('wallify-panel-open');
    document.documentElement.style.removeProperty('--wallify-panel-top');
    if (!document.querySelector('cart-drawer.active')) document.body.classList.remove('overflow-hidden');
    window.scrollTo({left:position.x, top:position.y, behavior:'instant'});
  };
  const cache = new Map();
  const versions = new WeakMap();
  const status = (text) => {
    const node = document.querySelector('[data-wishlist-status]');
    if (!node) return;
    node.textContent = text;
    clearTimeout(statusTimer);
    statusTimer = setTimeout(() => { node.textContent = ''; }, 4500);
  };
  const read = () => {
    try {
      const value = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(value) ? [...new Set(value.filter(v => typeof v === 'string' && /^[a-z0-9-]+$/.test(v)))].slice(0, 200) : [];
    } catch { return []; }
  };
  const readSelections = () => {
    try {
      const value = JSON.parse(localStorage.getItem(selectionsKey) || '{}');
      if (!value || typeof value !== 'object' || Array.isArray(value)) return {};
      return Object.fromEntries(Object.entries(value).filter(([handle, entry]) =>
        items.includes(handle) && entry && typeof entry === 'object'
      ).slice(0, 200).map(([handle, entry]) => [handle, {
        variant: typeof entry.variant === 'string' && /^\d+$/.test(entry.variant) ? entry.variant : '',
        premium: entry.premium === true,
        options: Array.isArray(entry.options) ? entry.options.slice(0, 3).map(value => typeof value === 'string' ? value.slice(0, 200) : '') : []
      }]));
    } catch { return {}; }
  };
  const saveSelection = (handle, selection) => {
    if (!items.includes(handle)) return;
    selections[handle] = selection;
    try { localStorage.setItem(selectionsKey, JSON.stringify(selections)); }
    catch { status(labels.storage); }
  };
  const rememberCard = card => {
    const master = card.querySelector('[data-wishlist-variant]');
    if (!master) return;
    const choices = [...card.querySelectorAll('[data-wishlist-choice]')];
    const selected = master.selectedOptions[0];
    saveSelection(card.dataset.wishlistCard, {
      variant: master.value || '',
      premium: card.dataset.premiumSelected === 'true',
      options: choices.length ? choices.map(select => select.value) : [1, 2, 3].map(i => selected?.dataset['o' + i]).filter(value => value !== undefined)
    });
  };
  const expandPremiumChoices = card => {
    if (card.dataset.premiumChoicesExpanded === 'true') return;
    const master = card.querySelector('[data-wishlist-variant]');
    if (!master) return;
    card.dataset.premiumChoicesExpanded = 'true';
    const materialLabel = card.querySelector('[data-wishlist-choices]')?.dataset.optionLabel1 || '';
    [...master.options].filter(option => option.value && !option.disabled && option.dataset.premiumId).forEach(option => {
      if ([...master.options].some(other => other.value === option.dataset.premiumId)) return;
      const premium = option.cloneNode(true);
      premium.value = option.dataset.premiumId;
      premium.dataset.premiumBase = option.value;
      premium.dataset.wishlistPremium = 'true';
      premium.dataset.o1 = labels.premiumMaterial;
      premium.dataset.l1 = labels.premiumMaterial;
      premium.dataset.price = option.dataset.premiumPrice;
      premium.dataset.formatted = option.dataset.premiumFormatted;
      premium.dataset.compareFormatted = option.dataset.premiumCompareFormatted || '';
      const tail = (option.dataset.summary || '').split('·').slice(1).map(text => text.trim()).join(' · ');
      premium.dataset.summary = materialLabel + ': ' + labels.premiumMaterial + (tail ? ' · ' + tail : '');
      master.add(premium);
    });
  };
  const restoreCard = card => {
    const master = card.querySelector('[data-wishlist-variant]');
    const saved = selections[card.dataset.wishlistCard];
    if (!master || !saved) return [];
    const variants = [...master.options].filter(option => option.value && !option.disabled);
    let match = variants.find(option => option.value === saved.variant || option.dataset.premiumId === saved.variant);
    const premiumSaved = saved.premium || variants.some(option => option.dataset.wishlistPremium === 'true' && option.value === saved.variant);
    if (premiumSaved && match?.dataset.wishlistPremium !== 'true') {
      const premium = variants.find(option => option.dataset.premiumBase === match?.value);
      if (premium) match = premium;
      else card.dataset.restorePremiumUnavailable = 'true';
    }
    card.dataset.premiumSelected = String(premiumSaved || match?.dataset.wishlistPremium === 'true' || Boolean(match?.dataset.premiumId === saved.variant));
    if (!match && saved.options.length && saved.options.every(Boolean)) {
      match = variants.find(option => saved.options.every((value, index) => option.dataset['o' + (index + 1)] === value));
    }
    if (match) {
      master.value = match.value;
      return [1, 2, 3].filter(i => match.dataset['o' + i] !== undefined).map(i => [String(i), match.dataset['o' + i]]);
    }
    if (saved.variant) {
      master.value = '';
      const message = card.querySelector('[data-wishlist-selection-status]');
      if (message) { message.hidden = false; message.textContent = labels.selectionUnavailable; }
      return [];
    }
    return saved.options.map((value, index) => [String(index + 1), value]);
  };
  const wishlistControls = '[data-wallify-favorite], [data-wishlist-count], [data-wishlist-open], .wallify-wishlist-header';
  const wishlistChrome = '[data-wishlist-count], [data-wishlist-open], .wallify-wishlist-header';
  const setAttributeIfChanged = (node, name, value) => {
    if (node.getAttribute(name) !== value) node.setAttribute(name, value);
  };
  const syncWishlistControl = node => {
    if (node.matches('[data-wallify-favorite]')) {
      const saved = items.includes(node.dataset.wallifyFavorite);
      const text = saved ? labels.remove : labels.add;
      setAttributeIfChanged(node, 'aria-pressed', String(saved));
      setAttributeIfChanged(node, 'aria-label', text);
      const label = node.querySelector('[data-favorite-label]');
      if (label && label.textContent !== text) label.textContent = text;
    }
    if (node.matches('[data-wishlist-count]')) {
      if (node.textContent !== String(items.length)) node.textContent = items.length;
      if (node.hidden !== !items.length) node.hidden = !items.length;
    }
    if (node.matches('[data-wishlist-open], .wallify-wishlist-header')) {
      if (!node.dataset.wishlistBaseLabel) node.dataset.wishlistBaseLabel = node.getAttribute('aria-label') || labels.title;
      setAttributeIfChanged(node, 'aria-label', node.dataset.wishlistBaseLabel + (items.length ? ', ' + (items.length === 1 ? labels.savedOne || labels.savedCount : labels.savedCount).replace('{count}', items.length) : ''));
    }
  };
  const syncButtons = () => document.querySelectorAll(wishlistControls).forEach(syncWishlistControl);
  const fetchCard = async handle => {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    try {
      const fetchSection = path => fetch(path, {credentials:'same-origin',cache:'no-store',signal:controller.signal});
      let response = await fetchSection(root + 'products/' + encodeURIComponent(handle) + '?section_id=wallify-wishlist-card');
      if (!response.ok) throw new Error('Unavailable');
      let doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      let card = doc.querySelector('[data-wishlist-card]');
      if (!card) {
        const redirected = new URL(response.url);
        if (redirected.origin === location.origin && redirected.pathname.includes('/products/') && !redirected.searchParams.has('section_id')) {
          redirected.searchParams.set('section_id','wallify-wishlist-card');
          response = await fetchSection(redirected.href);
          if (response.ok) {
            doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            card = doc.querySelector('[data-wishlist-card]');
          }
        }
      }
      if (!card) throw new Error('Unavailable');
      card.dataset.wishlistCard = handle;
      card.querySelectorAll('[data-wallify-favorite]').forEach(b => { b.dataset.wallifyFavorite = handle; });
      return card;
    } finally { clearTimeout(timeout); }
  };
  const cardFor = async handle => {
    if (!cache.has(handle)) {
      cache.set(handle, fetchCard(handle).catch(() => fetchCard(handle)).catch(error => { cache.delete(handle); throw error; }));
    }
    return (await cache.get(handle)).cloneNode(true);
  };
  const selectedVariant = card => {
    const master = card.querySelector('[data-wishlist-variant]');
    const option = master?.value && !master.selectedOptions[0]?.disabled ? master.selectedOptions[0] : null;
    if (!option) return null;
    if (card.dataset.premiumSelected === 'true' && !option.dataset.premiumId) return null;
    const premium = card.dataset.premiumSelected === 'true';
    return {id: premium ? option.dataset.premiumId : option.value,
      price: Number(premium ? option.dataset.premiumPrice : option.dataset.price),
      formatted: premium ? option.dataset.premiumFormatted : option.dataset.formatted,
      compareFormatted: (premium ? option.dataset.premiumCompareFormatted : option.dataset.compareFormatted) || ''};
  };
  const quickBuyPricePreview = card => {
    if (card.dataset.quickBuy !== 'true') return null;
    const choices = [...card.querySelectorAll('[data-wishlist-choice]')].filter(choice => choice.value);
    if (!choices.length) return null;
    const candidates = [...card.querySelector('[data-wishlist-variant]').options].filter(option => option.value && !option.disabled && choices.every(choice => option.dataset['o' + choice.dataset.wishlistChoice] === choice.value));
    const minimum = candidates.reduce((best, option) => !best || Number(option.dataset.price) < Number(best.dataset.price) ? option : best, null);
    if (!minimum) return null;
    const varies = candidates.some(option => Number(option.dataset.price) !== Number(minimum.dataset.price));
    return {
      formatted: varies ? (card.dataset.priceFrom || '__wallify_price__').replace('__wallify_price__', minimum.dataset.formatted) : minimum.dataset.formatted,
      compareFormatted: minimum.dataset.compareFormatted || '',
      summary: choices.map(choice => (choice.getAttribute('aria-label') || '') + ': ' + (minimum.dataset['l' + choice.dataset.wishlistChoice] || choice.selectedOptions[0].textContent)).join(' · ')
    };
  };
  const selectedForCart = () => [...document.querySelectorAll('.wallify-wishlist-page [data-wishlist-card]')].filter(card => cartSelection.has(card.dataset.wishlistCard) && selectedVariant(card));
  const updateTotal = () => {
    const page = document.querySelector('.wallify-wishlist-page');
    if (!page) return;
    const selected = selectedForCart();
    const count = page.querySelector('[data-wishlist-total]');
    const button = page.querySelector('[data-wishlist-add-all]');
    if (!count || !button) return;
    const total = selected.reduce((sum,card) => sum + selectedVariant(card).price,0);
    let formatted = '';
    try { formatted = new Intl.NumberFormat(document.documentElement.lang,{style:'currency',currency:window.Shopify.currency.active}).format(total/100); } catch {}
    count.textContent = (selected.length === 1 ? count.dataset.one : count.dataset.many).replace('{count}',selected.length);
    page.querySelector('[data-wishlist-total-price]').textContent = formatted;
    const summary = page.querySelector('.wallify-wishlist-summary');
    summary.dataset.hasSelection = String(Boolean(selected.length));
    button.disabled = !selected.length || bulkBusy || selected.some(card => card.dataset.cartBusy === 'true');
  };
  const populate = async (list) => {
    const version = (versions.get(list) || 0) + 1;
    versions.set(list, version);
    list.replaceChildren();
    list.setAttribute('aria-busy', 'true');
    list.dataset.itemCount = String(items.length);
    const empty = list.parentElement.querySelector('[data-wishlist-empty]');
    if (empty) empty.hidden = items.length > 0;
    const summary = list.closest('.wallify-wishlist-page')?.querySelector('.wallify-wishlist-summary');
    if (summary) summary.hidden = !items.length;
    const handles = [...items].reverse();
    const slots = handles.map(handle => {
      const slot = document.createElement('div');
      slot.textContent = labels.loading;
      list.append(slot);
      return {handle, slot};
    });
    let index = 0;
    const worker = async () => {
      while (index < slots.length) {
        const {handle, slot} = slots[index++];
        try {
          const card = await cardFor(handle);
          if (versions.get(list) !== version) return;
          expandPremiumChoices(card);
          const savedChoices = restoreCard(card);
          if (list.dataset.wishlistMode === 'page') initChoices(card, savedChoices);
          updateVariant(card);
          slot.replaceWith(card);
          updateTotal();
          
        } catch {
          if (versions.get(list) !== version) return;
          slot.className = 'wallify-wishlist-unavailable';
          const message = document.createElement('p');
          message.textContent = labels.unavailable;
          const actions = document.createElement('div');
          const retry = document.createElement('button');
          retry.type = 'button';
          retry.dataset.wishlistRetry = handle;
          retry.className = 'wallify-wishlist-retry';
          retry.textContent = labels.retry;
          const remove = document.createElement('button');
          remove.type = 'button';
          remove.dataset.wallifyFavorite = handle;
          remove.className = 'wallify-wishlist-remove-unavailable';
          remove.textContent = labels.remove;
          actions.append(retry,remove);
          slot.replaceChildren(message, actions);
        }
        syncButtons();
        
      }
    };
    await Promise.all([worker(), worker(), worker(), worker()]);
    if (versions.get(list) !== version) return;
    list.setAttribute('aria-busy', 'false');
    updateTotal();
    syncButtons();
    
  };
  const render = () => {
    syncButtons();
    document.querySelectorAll('[data-wishlist-list]').forEach(list => {
      if (list.dataset.wishlistMode === 'page' || dialog.open) populate(list);
    });
  };
  const initChoices = (card, savedChoices = []) => {
    const box = card.querySelector('[data-wishlist-choices]');
    const master = card.querySelector('[data-wishlist-variant]');
    if (!box || !master) return;
    const variants = [...master.options].filter(o => o.value);
    const dimensions = [1,2,3].filter(i => variants.some(o => o.dataset['o'+i]));
    const chosen = master.value ? master.selectedOptions[0] : null;
    const saved = new Map(savedChoices);
    box.replaceChildren();
    dimensions.forEach((i, index) => {
      const label = document.createElement('label');
      label.textContent = box.dataset['optionLabel' + i] || labels.choose;
      const select = document.createElement('select');
      select.dataset.wishlistChoice = i;
      select.setAttribute('aria-label', label.textContent);
      label.append(select);box.append(label);
    });
    const rebuild = (changed = 0) => {
      const selectors = [...box.querySelectorAll('select')];
      selectors.forEach((select,index) => {
        const previous = selectors.slice(0,index);
        const candidates = variants.filter(o => !o.disabled && previous.every(s => s.value && o.dataset['o'+s.dataset.wishlistChoice] === s.value));
        const position = select.dataset.wishlistChoice;
        const old = select.value || (changed === 0 ? saved.get(position) || chosen?.dataset['o'+position] : '');
        const values = new Map(candidates.map(o => [o.dataset['o'+position],o.dataset['l'+position] || o.dataset['o'+position]]));
        const placeholder = new Option(box.dataset.choose,'');
        placeholder.disabled = true;
        placeholder.hidden = true;
        select.replaceChildren(placeholder);
        values.forEach((text,value) => {
          let optionText = text.trim();
          if (card.dataset.quickBuy === 'true' && position === '2') {
            const matching = candidates.filter(o => o.dataset['o'+position] === value);
            const minimum = matching.reduce((best, option) => !best || Number(option.dataset.price) < Number(best.dataset.price) ? option : best, null);
            if (minimum?.dataset.formatted) optionText += ' — ' + minimum.dataset.formatted;
          }
          select.add(new Option(optionText,value));
        });
        select.value = '';
        select.disabled = index > 0 && previous.some(s => !s.value);
        if (values.has(old) && (!changed || index < changed || card.dataset.quickBuy === 'true')) select.value = old;
        else if (values.size === 1) select.value = [...values.keys()][0];
        select.closest('label').hidden = (values.size === 1 && (position === '3' || card.dataset.quickBuy === 'true')) || (position === '3' && !values.size);
        select.title = select.selectedOptions[0]?.text || '';
      });
      const match = variants.find(o => !o.disabled && selectors.every(s => s.value && o.dataset['o'+s.dataset.wishlistChoice] === s.value));
      master.value = match?.value || '';
      updateVariant(card);
    };
    box.addEventListener('change', event => {
      const index = dimensions.indexOf(Number(event.target.dataset.wishlistChoice));
      delete card.dataset.restorePremiumUnavailable;
      card.querySelector('[data-wishlist-selection-status]')?.setAttribute('hidden', '');
      rebuild(index + 1);
      if (card.dataset.quickBuy !== 'true') rememberCard(card);
      document.querySelectorAll('[data-wishlist-card]').forEach(other => {
        if (card.dataset.quickBuy !== 'true' && other !== card && other.dataset.quickBuy !== 'true' && other.dataset.wishlistCard === card.dataset.wishlistCard) { restoreCard(other); updateVariant(other); }
      });
    });
    rebuild();
  };
  const updateVariant = card => {
    const price = card.querySelector('[data-wishlist-price]');
    // Current price and struck compare-at price are separate children, so writing one never wipes the other
    const current = price?.querySelector('[data-wishlist-price-current]') || price;
    const compare = price?.querySelector('[data-wishlist-price-compare]');
    if (current && !current.dataset.initial) current.dataset.initial = current.textContent;
    if (compare && compare.dataset.initial === undefined) compare.dataset.initial = compare.hidden ? '' : compare.querySelector('s').textContent;
    const select = card.querySelector('[data-wishlist-variant]');
    const selected = select?.value && !select.selectedOptions[0]?.disabled ? select.selectedOptions[0] : null;
    const button = card.querySelector('[data-wishlist-add]');
    if (selected && !card.dataset.restorePremiumUnavailable) card.dataset.premiumSelected = String(selected.dataset.wishlistPremium === 'true');
    const premiumUnavailable = card.dataset.premiumSelected === 'true' && selected && !selected.dataset.premiumId;
    if (button) button.disabled = !selected || premiumUnavailable || card.dataset.cartBusy === 'true';
    const edit = card.querySelector('[data-wishlist-edit]');
    if (edit) edit.hidden = card.dataset.premiumSelected !== 'true';
    const selectionMessage = card.querySelector('[data-wishlist-selection-status]');
    if (premiumUnavailable && selectionMessage) {
      selectionMessage.hidden = false;
      selectionMessage.textContent = labels.selectionUnavailable;
    }
    const effective = selectedVariant(card);
    const previewPrice = quickBuyPricePreview(card);
    const displayPrice = effective || previewPrice;
    const include = card.querySelector('[data-wishlist-include]');
    if (include) {
      if (!effective) cartSelection.delete(card.dataset.wishlistCard);
      include.checked = cartSelection.has(card.dataset.wishlistCard);
      include.disabled = !effective || card.dataset.cartBusy === 'true';
    }
    const personalConfig = card.querySelector('[data-wishlist-personal-variants]');
    const savedPersonal = personalConfig && selections[card.dataset.wishlistCard];
    const selectedPersonal = savedPersonal && JSON.parse(personalConfig.textContent).find(v => String(v.id) === savedPersonal.variant && v.available);
    if (current) current.textContent = displayPrice ? displayPrice.formatted : selectedPersonal?.money || current.dataset.initial;
    if (compare) {
      const compareText = displayPrice ? displayPrice.compareFormatted : selectedPersonal ? selectedPersonal.compareMoney || '' : compare.dataset.initial;
      compare.querySelector('s').textContent = compareText;
      compare.hidden = !compareText;
    }
    card.dataset.onSale = String(Boolean(compare && !compare.hidden));
    card.querySelectorAll('[data-quickbuy-discount]').forEach(badge => { badge.hidden = !compare || compare.hidden; });
    const headingPrice = card.querySelector('[data-quickbuy-price-top]');
    if (headingPrice) {
      headingPrice.querySelector('[data-quickbuy-price-current]').textContent = current.textContent;
      const headingCompare = headingPrice.querySelector('[data-quickbuy-price-compare]');
      headingCompare.hidden = !compare || compare.hidden;
      headingCompare.querySelector('s').textContent = compare?.querySelector('s').textContent || '';
    }
    card.querySelectorAll('[data-wishlist-product-link]').forEach(link => {
      if (!link.dataset.baseHref) link.dataset.baseHref = link.getAttribute('href');
      const url = new URL(link.dataset.baseHref, location.origin);
      if (selected) url.searchParams.set('variant', selected.dataset.premiumBase || selected.value);
      else if (selectedPersonal) url.searchParams.set('variant', String(selectedPersonal.id));
      if (card.dataset.premiumSelected === 'true') url.searchParams.set('frame_upgrade', 'premium');
      else url.searchParams.delete('frame_upgrade');
      link.href = url.href;
    });
    const image = card.querySelector('[data-wishlist-image] img');
    if (image) {
      if (!image.dataset.initialSrc) {
        image.dataset.initialSrc = image.getAttribute('src');
        image.dataset.initialSrcset = image.getAttribute('srcset') || '';
      }
      image.src = selected?.dataset.image || image.dataset.initialSrc;
      if (selected?.dataset.image) image.removeAttribute('srcset');
      else if (image.dataset.initialSrcset) image.setAttribute('srcset', image.dataset.initialSrcset);
    }
    const frame = card.querySelector('[data-wishlist-frame]');
    const showFrame = Boolean(frame && selected?.dataset.frame);
    if (frame) {
      frame.hidden = !showFrame;
      const preview = frame.querySelector('wallify-frame-preview');
      if (showFrame && preview) {
        preview.dataset.frame = selected.dataset.frame;
        const artwork = preview.querySelector('img');
        const artworkRatio = Number(artwork?.getAttribute('width')) / Number(artwork?.getAttribute('height'));
        preview.style.setProperty('--wallify-thumb-fit', String(Number.isFinite(artworkRatio) && artworkRatio > 0 ? Math.min(1, artworkRatio) : .714286));
        preview.setAttribute('aria-label', card.querySelector('.wallify-wishlist-card__title').textContent.trim() + ', ' + selected.dataset.summary);
      }
    }
    const originalImage = card.querySelector('[data-wishlist-image]');
    if (originalImage) originalImage.hidden = showFrame;
    const summary = card.querySelector('[data-wishlist-config-summary]');
    if (summary && personalConfig) {
      summary.hidden = !selectedPersonal;
      summary.textContent = selectedPersonal?.summary || '';
      return;
    }
    if (summary) {
      summary.hidden = !(selected?.dataset.summary || previewPrice?.summary);
      summary.textContent = (selected?.dataset.summary || previewPrice?.summary || '') + (selected?.dataset.framed && card.dataset.premiumSelected === 'true' && (card.dataset.premiumLabel || labels.premium) ? ' · ' + (card.dataset.premiumLabel || labels.premium) : '');
    }
  };
  // Opens like the cart drawer: one panel at a time, page scroll locked with the same body class the cart drawer uses
  const openDrawer = () => {
    if (dialog.open) return;
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer?.classList.contains('active')) cartDrawer.close();
    if (quickDialog?.open) quickDialog.close();
    lockPage();
    dialog.classList.remove('is-closing');
    dialog.showModal();
    document.body.classList.add('overflow-hidden');
  };
  const closeDrawer = () => {
    if (!dialog.open || dialog.classList.contains('is-closing')) return;
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) { dialog.close(); return; }
    dialog.classList.add('is-closing');
    setTimeout(() => dialog.close(), 200);
  };
  const closeQuickBuy = () => {
    quickVersion++;
    if (quickDialog?.open) quickDialog.close();
  };
  const openQuickBuy = async opener => {
    const handle = opener.dataset.productHandle;
    if (!quickDialog || !/^[a-z0-9-]+$/.test(handle || '')) return;
    if (quickDialog.open && quickDialog.dataset.handle === handle) return;
    quickOrigin = opener;
    const version = ++quickVersion;
    if (dialog.open) dialog.close();
    const cart = document.querySelector('cart-drawer');
    if (cart?.classList.contains('active')) cart.close();
    lockPage();
    quickDialog.dataset.handle = handle;
    const host = quickDialog.querySelector('[data-quick-buy-body]');
    const loading = document.createElement('p');
    loading.className = 'wallify-quickbuy-message';
    loading.setAttribute('role','status');
    loading.textContent = labels.loading;
    host.replaceChildren(loading);
    if (!quickDialog.open) quickDialog.showModal();
    opener.setAttribute('aria-busy','true');
    try {
      cache.delete(handle);
      const card = await cardFor(handle);
      if (version !== quickVersion || !quickDialog.open) return;
      if (card.dataset.personalized === 'true' || card.dataset.quickBuyRestricted === 'true') {
        location.assign(card.querySelector('[data-wishlist-product-link]').href);
        return;
      }
      expandPremiumChoices(card);
      card.dataset.quickBuy = 'true';
      card.dataset.premiumSelected = 'false';
      const productUrl = card.querySelector('[data-wishlist-product-link]')?.href || root + 'products/' + encodeURIComponent(handle);
      const head = document.createElement('div');
      head.className = 'wallify-quickbuy-product';
      const image = card.querySelector('.wallify-wishlist-card__image');
      image?.querySelectorAll('button,.wallify-wishlist-card__badges').forEach(node => node.remove());
      if (image) head.append(image);
      const heading = document.createElement('div');
      heading.className = 'wallify-quickbuy-heading';
      heading.append(card.querySelector('.wallify-wishlist-card__title'));
      const price = card.querySelector('[data-wishlist-price]');
      const discount = card.querySelector('.wallify-wishlist-card__meta .wallify-offer-badge')?.cloneNode(true);
      if (discount) {
        discount.dataset.quickbuyDiscount = '';
        discount.classList.add('wallify-quickbuy-discount');
        price.append(discount);
      }
      const headingPrice = price.cloneNode(true);
      headingPrice.removeAttribute('data-wishlist-price');
      headingPrice.dataset.quickbuyPriceTop = '';
      const headingCurrent = headingPrice.querySelector('[data-wishlist-price-current]');
      headingCurrent.removeAttribute('data-wishlist-price-current');
      headingCurrent.dataset.quickbuyPriceCurrent = '';
      const headingCompare = headingPrice.querySelector('[data-wishlist-price-compare]');
      headingCompare.removeAttribute('data-wishlist-price-compare');
      headingCompare.dataset.quickbuyPriceCompare = '';
      heading.append(headingPrice);
      head.append(heading);
      const purchase = card.querySelector('.wallify-wishlist-card__purchase');
      const footer = document.createElement('div');
      footer.className = 'wallify-quickbuy-footer';
      const priceRow = document.createElement('div');
      priceRow.className = 'wallify-quickbuy-price-row';
      const summary = card.querySelector('[data-wishlist-config-summary]');
      priceRow.append(price, summary);
      footer.append(priceRow);
      const button = card.querySelector('[data-wishlist-add]');
      if (button) footer.append(button);
      const message = card.querySelector('[data-wishlist-selection-status]');
      purchase.append(message);
      const details = document.createElement('a');
      details.className = 'wallify-quickbuy-details';
      details.dataset.wishlistProductLink = '';
      details.href = productUrl;
      details.textContent = labels.details;
      purchase.append(details);
      card.replaceChildren(head,purchase,footer);
      initChoices(card);
      updateVariant(card);
      host.replaceChildren(card);
    } catch {
      if (version !== quickVersion || !quickDialog.open) return;
      const error = document.createElement('p');
      error.className = 'wallify-quickbuy-message';
      error.setAttribute('role','alert');
      error.textContent = labels.error;
      const details = document.createElement('a');
      details.className = 'wallify-quickbuy-details';
      details.href = root + 'products/' + encodeURIComponent(handle);
      details.textContent = labels.details;
      host.replaceChildren(error, details);
    } finally {
      opener.removeAttribute('aria-busy');
    }
  };
  const onQuickBuyTrigger = event => {
    const opener = event.target.closest('quick-view[data-product-handle]');
    if (!opener || !quickDialog) return;
    if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    openQuickBuy(opener);
  };
  document.addEventListener('click', onQuickBuyTrigger, true);
  document.addEventListener('keydown', onQuickBuyTrigger, true);
  if (quickDialog) {
    quickDialog.querySelector('[data-quick-buy-close]').addEventListener('click', closeQuickBuy);
    quickDialog.addEventListener('cancel', event => { event.preventDefault(); closeQuickBuy(); });
    quickDialog.addEventListener('click', event => {
      if (event.target !== quickDialog) return;
      const box = quickDialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) closeQuickBuy();
    });
    quickDialog.addEventListener('close', () => {
      quickVersion++;
      unlockPage();
      if (!dialog.open && !document.querySelector('cart-drawer.active')) quickOrigin?.focus({preventScroll:true});
    });
  }
  const submitCartItems = async (cartItems, origin) => {
      const cart = document.querySelector('cart-drawer');
      const sectionIds = cart?.getSectionsToRender?.().map(section => section.id) || [];
      const body = {items:cartItems};
      if (sectionIds.length) {
        body.sections = sectionIds;
        body.sections_url = location.pathname;
      }
      const response = await fetch(root + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, credentials:'same-origin', body:JSON.stringify(body)});
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || labels.error);
      if (quickDialog?.open) closeQuickBuy();
      if (dialog.open) dialog.close();
      if (cart && sectionIds.every(id => typeof result.sections?.[id] === 'string' && result.sections[id])) {
        cart.setActiveElement(origin);
        cart.classList.remove('is-empty');
        try { cart.renderContents(result); }
        catch { location.assign(root + 'cart'); }
      } else {
        location.assign(root + 'cart');
      }
  };
  const addToCart = async (card, button) => {
    const variant = selectedVariant(card);
    if (!variant || button.disabled) return;
    const requestKey = card.dataset.wishlistCard + ':' + variant.id;
    if (pendingAdds.has(requestKey)) return;
    pendingAdds.add(requestKey);
    card.dataset.cartBusy = 'true';
    button.disabled = true;
    button.setAttribute('aria-busy','true');
    const oldText = button.textContent;
    button.textContent = labels.loading;
    const message = card.querySelector('[data-wishlist-selection-status]');
    if (message) message.hidden = true;
    const origin = card.dataset.quickBuy === 'true' ? quickOrigin : button;
    updateVariant(card);
    updateTotal();
    const operation = cartQueue.then(async () => {
      await submitCartItems([{id:Number(variant.id),quantity:1}], origin);
      cartSelection.delete(card.dataset.wishlistCard);
      if (message) { message.textContent = labels.added; message.hidden = false; }
    });
    cartQueue = operation.catch(() => {});
    try { await operation; }
    catch (error) {
      if (message) { message.textContent = error.message || labels.error; message.hidden = false; }
      else status(labels.error);
    } finally {
      pendingAdds.delete(requestKey);
      delete card.dataset.cartBusy;
      button.removeAttribute('aria-busy');
      button.textContent = oldText;
      updateVariant(card);
      updateTotal();
    }
  };
  const addMultipleToCart = async button => {
    if (button.disabled || bulkBusy) return;
    const cards = selectedForCart();
    if (!cards.length || cards.some(card => card.dataset.cartBusy === 'true')) return;
    const cartItems = cards.map(card => ({id:Number(selectedVariant(card).id),quantity:1}));
    const requestKeys = cards.map((card,index) => card.dataset.wishlistCard + ':' + cartItems[index].id);
    if (requestKeys.some(key => pendingAdds.has(key))) return;
    bulkBusy = true;
    requestKeys.forEach(key => pendingAdds.add(key));
    cards.forEach(card => { card.dataset.cartBusy = 'true'; updateVariant(card); });
    button.setAttribute('aria-busy','true');
    updateTotal();
    const operation = cartQueue.then(async () => {
      await submitCartItems(cartItems,button);
      cards.forEach(card => cartSelection.delete(card.dataset.wishlistCard));
    });
    cartQueue = operation.catch(() => {});
    try { await operation; }
    catch (error) { status(error.message || labels.error); }
    finally {
      requestKeys.forEach(key => pendingAdds.delete(key));
      cards.forEach(card => { delete card.dataset.cartBusy; updateVariant(card); });
      bulkBusy = false;
      button.removeAttribute('aria-busy');
      updateTotal();
    }
  };
  document.addEventListener('click', event => {
    const viewLink = event.target.closest('[data-wishlist-view]');
    if (viewLink) {
      event.preventDefault();
      window.location.assign(viewLink.href);
      return;
    }
    const retry = event.target.closest('[data-wishlist-retry]');
    if (retry) { cache.delete(retry.dataset.wishlistRetry); populate(retry.closest('[data-wishlist-list]')); return; }
    const favorite = event.target.closest('[data-wallify-favorite]');
    if (favorite) {
      event.preventDefault();
      const handle = favorite.dataset.wallifyFavorite;
      const next = items.includes(handle) ? items.filter(item => item !== handle) : [...items, handle];
      try { localStorage.setItem(key, JSON.stringify(next)); }
      catch { status(labels.storage); return; }
      items = next;
      if (items.includes(handle)) {
        const product = favorite.closest('.product');
        const variantInput = product?.querySelector('form[action*="/cart/add"] [name="id"]');
        if (variantInput?.value && /^\d+$/.test(variantInput.value)) saveSelection(handle, {variant: variantInput.value, options: []});
      } else {
        cartSelection.delete(handle);
        delete selections[handle];
        try { localStorage.setItem(selectionsKey, JSON.stringify(selections)); } catch {}
      }
      render();
      return;
    }
    if (event.target.closest('[data-wishlist-open]')) {
      event.preventDefault();
      openDrawer();
      cache.clear();
      populate(dialog.querySelector('[data-wishlist-list]'));
    }
    if (event.target.closest('[data-wishlist-close]')) closeDrawer();
    const add = event.target.closest('[data-wishlist-add]');
    if (add) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (add.disabled) return;
      addToCart(add.closest('[data-wishlist-card]'), add);
      return;
    }
    const multiple = event.target.closest('[data-wishlist-add-all]');
    if (multiple) { event.preventDefault(); addMultipleToCart(multiple); return; }
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-wishlist-include]')) {
      const card = event.target.closest('[data-wishlist-card]');
      if (event.target.checked && selectedVariant(card)) cartSelection.add(card.dataset.wishlistCard);
      else cartSelection.delete(card.dataset.wishlistCard);
      updateTotal();
      return;
    }
    if (!event.target.matches('[data-wishlist-variant]')) return;
    const card = event.target.closest('[data-wishlist-card]');
    updateVariant(card);
    if (card.dataset.quickBuy !== 'true') rememberCard(card);
    updateTotal();
  });
  dialog.addEventListener('click', event => { if (event.target === dialog && event.clientX < dialog.getBoundingClientRect().left) closeDrawer(); });
  // Esc: same slide-out as the close button; the native close then returns focus to the header heart
  dialog.addEventListener('cancel', event => { event.preventDefault(); closeDrawer(); });
  dialog.addEventListener('close', () => { dialog.classList.remove('is-closing'); unlockPage(); });
  window.addEventListener('storage', event => { if (event.key === key || event.key === selectionsKey || event.key === null) { items = read(); selections = readSelections(); cache.clear(); render(); } });
  window.addEventListener('pageshow', event => { if (event.persisted) { items = read(); selections = readSelections(); cache.clear(); render(); } });
  const pendingWishlistControls = new Set();
  let syncButtonsFrame = null;
  let refreshWishlistChrome = false;
  const collectWishlistControls = node => {
    if (!(node instanceof Element)) return;
    if (node.matches(wishlistControls)) pendingWishlistControls.add(node);
    node.querySelectorAll(wishlistControls).forEach(control => pendingWishlistControls.add(control));
  };
  const scheduleWishlistSync = records => {
    records.forEach(record => {
      const target = record.target instanceof Element ? record.target : record.target.parentElement;
      const control = target?.closest(wishlistControls);
      if (control) pendingWishlistControls.add(control);
      record.addedNodes.forEach(collectWishlistControls);
      record.removedNodes.forEach(node => {
        if (node instanceof Element && (node.matches(wishlistControls) || node.querySelector(wishlistControls))) {
          refreshWishlistChrome = true;
        }
      });
    });
    if ((!pendingWishlistControls.size && !refreshWishlistChrome) || syncButtonsFrame !== null) return;
    syncButtonsFrame = requestAnimationFrame(() => {
      syncButtonsFrame = null;
      if (refreshWishlistChrome) {
        document.querySelectorAll(wishlistChrome).forEach(control => pendingWishlistControls.add(control));
        refreshWishlistChrome = false;
      }
      const controls = [...pendingWishlistControls];
      pendingWishlistControls.clear();
      controls.forEach(control => {
        if (control.isConnected) syncWishlistControl(control);
      });
    });
  };
  const mainContent = document.getElementById('MainContent');
  if (mainContent) new MutationObserver(scheduleWishlistSync).observe(mainContent, {childList:true, subtree:true});
  document.addEventListener('shopify:section:load', syncButtons);
  const wishlistSummary = document.querySelector('.wallify-wishlist-page .wallify-wishlist-summary');
  if (wishlistSummary && typeof ResizeObserver === 'function') {
    new ResizeObserver(() => {
      document.documentElement.style.setProperty('--wallify-wishlist-summary-height', Math.ceil(wishlistSummary.getBoundingClientRect().height) + 'px');
    }).observe(wishlistSummary);
  }
  items = read();
  selections = readSelections();
  render();
})();




